<template>
<div class="article page-container" :class="[fields.template, fields.uid]">
  <!-- Main -->
  <main :class="['main', fields.uid, fields.template]">
		<!-- Breadcrumbs -->
		<!-- <aside class="breadcrumb text-bold text-extended" style="opacity: 1;">
      <span class="page-title">{{ fields.title }}</span>
      <template  v-if="active_section">
      	<span :data-text="humanizeSlug(active_section)" id="section-title" class="section-title">{{ humanizeSlug(active_section) }}</span>
      </template>
      
    </aside> -->
    <!-- Tickers -->
    <template v-for="(ticker, index) in tickers">
	    <div class="ticker loaded" :data-title="ticker.primary.ticker_text" :class="[ticker.primary.ticker_color]">
			  <div>
			  	<marquee-text :duration="60">
			  	  <h3 class="ticker-item fs-normal">{{ ticker.primary.ticker_text }}</h3>
			  	  <span class="ticker-item performa fs-normal">Performa</span>
			  	  <span class="ticker-item fs-normal">{{ ticker.primary.ticker_text }}</span>
			  	  <span class="ticker-item performa fs-normal">Performa</span>
			  	</marquee-text>
			  </div>
	    </div>
    </template>
    		<div class="relative">
		    <figure class="featured-image" :class="fields.desktop_featured_image_crop_point" @click="showPhotoSwipe(0)">
		    	<prismic-image :field="fields.featured_image"/>
			    <figcaption><prismic-rich-text :field="fields.featured_image_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
	    	</figure>
	
			
    <section class="page-content">
	    <template v-for="(slice, index) in slices">
		    <template v-if="slice.slice_type === 'title'">
			    <article class="breadcrumb-trigger" :data-title="slice.primary.section_title" ref="sanitizeTitle(slice.primary.section_title).toString()">
					<h2 class="text-condensed text-uppercase text-left" :id="sanitizeTitle(slice.primary.section_title)"><strong>{{ slice.primary.section_title }}</strong></h2>
			    </article>
		    </template>
		    <template v-if="slice.slice_type === 'text'">
			    <article class="text">
					<prismic-rich-text :field="slice.primary.section_text" :class="slice.primary.section_text_class"/>
			    </article>
		    </template>
		    <template v-else-if="slice.slice_type === 'image'">
			    <article>
				    <figure class="img img-landscape" @click="showPhotoSwipe(index)">
				    	<img v-lazy="slice.primary.section_image.url" />
					    <figcaption><prismic-rich-text :field="slice.primary.section_image_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
				    </figure>        
			    </article>
		    </template>
		    <template v-else-if="slice.slice_type === 'carousel'">
			    <carousel :adjustableHeight="true" :autoplay="true" :loop="true" :centerMode="true" :per-page="1" paginationColor="#ffffff" :paginationSize="8" :paginationPadding="4" :speed="250":autoplayTimeout="5000">
				    <slide v-for="(item, index) in slice.items" class="carousel-slide" :key="item.id">
					    <figure class="img" @click="showPhotoSwipe(index)">
					    <picture>
						    <!-- <source :srcset="item.slide_image.mobile.url" media="(max-width: 767px)"> -->
					      <img :src="item.slide_image.url">
					    </picture>
	            <figcaption><prismic-rich-text :field="item.slide_caption" :htmlSerializer="innerSingleParagraph"/>
	            </figcaption>
					    </figure>
	          </slide>
			    </carousel>
		    </template>
		    <template v-else-if="slice.slice_type === 'image_grid'">
			    <div class="grid-container c3 image-grid">
				    <div v-for="(item, x) in slice.items" class="grid-image" v-lazy-container="{ selector: 'img' }">
					    <figure class="img img-landscape" @click="showPhotoSwipe(index)">
					      <img :data-src="item.grid_image.url">
	            <figcaption><prismic-rich-text :field="item.grid_image_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
					    </figure>
				    </div>
			    </div>
		    </template>
		    <template v-else-if="slice.slice_type === 'cta'">
		    	<article>
			    	<template v-for="(item, index) in slice.items">
				    	<prismic-link :field="item.cta_link" class="cta btn">
				    	<span>{{ item.cta_text }}</span>
				    	</prismic-link>
			    	</template>
		    	</article>
		    </template>
		    <template v-else-if="slice.slice_type === 'video'">
			    <article class="article-video">
				  <figure class="img"   :class="[muted ? 'muted' : '']">					    
    			<div class="rb-video-wrap video-wrap"  @click="toggleMuted">
	          <video id="rb-video" playsinline="" autoplay="" loop="" :muted="muted" preload="auto">
	          	<source :src="slice.primary.video_link.url" type="video/mp4">
	          </video>
          </div>
          <figcaption><prismic-rich-text :field="slice.primary.video_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
				  </figure>
			    </article>
		    </template>
		    <template v-else-if="slice.slice_type === 'image_banner'">
			    <figure class="img">

            <figcaption><prismic-rich-text :field="slice.primary.banner_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
          </figure>
		    </template>
		    <template v-else-if="slice.slice_type === 'horizontal_break'">
			    <article>
			    <hr>
			    </article>
		    </template>
		    <template v-else-if="slice.slice_type === 'pull_quote'">
			    <article>
				    <aside class="pquote">
				    <blockquote>
				      <prismic-rich-text :field="slice.primary.quote_text" :htmlSerializer="innerSingleParagraph"/>
				    </blockquote>
				    <template v-if="slice.primary.quote_author">
				    <prismic-rich-text :field="slice.primary.quote_author" :htmlSerializer="innerSingleParagraph" class="pquote-author"/>
				    </template>
						</aside>
			    </article>
		    </template>
		    <template v-else-if="slice.slice_type === 'expander'">
			    <article>
				    <ul class="grid-list text-smaller">
					    
					    <Expander v-for="(item, index) in slice.items" :key="item.id" :expander="item">
		          </Expander>
	          
				    </ul>
			    </article>
 		    </template>
	        <template v-else-if="slice.slice_type === 'code_snippet'">
	    	    <article v-html="$prismic.richTextAsPlain(slice.primary.code_snippet)" :key="index" ></article>
	        </template>	    
	    </template>
	    
	    <v-photoswipe :isOpen="isOpen" :items="items" :options="options" @close="hidePhotoSwipe"></v-photoswipe>

    </section>
</div>
  </main>
  <prismic-edit-button :documentId="documentId"/>
</div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import prismicDOM from 'prismic-dom';
import Expander from '../components/Expander.vue';
import { PhotoSwipe, PhotoSwipeGallery } from 'v-photoswipe';
 
const Elements = prismicDOM.RichText.Elements;
	
const innerSingleParagraph = function (type, element, content, children) {
  if (type === Elements.paragraph) {
    return `${children.join('')}`;
  }
  return null;
}

const toggleClass = function (target, addRemoveClass, className) {
  if (addRemoveClass === 'addClass') {
    target.classList.add(className);
  } else {
    target.classList.remove(className);
  }
}

export default {
  name: 'Page',
  props: ['active_section'],
  data () {
    return {
	    innerSingleParagraph,
      documentId: '',
      loading: true,
      fields: {
	      uid: null,
        title: null,
        date: null,
        description: null,
        template: null,
        featured_image: null,
        featured_image_caption: null,
        desktop_featured_image_crop_point: null
      },
      slices: [],
      tickers: [],
      muted: true,
      mounted: false,
      isOpen: false,
      isOpenGallery: false,
      options: {
        index: 0,
        showHideOpacity: true,
        history: false
      },
      optionsGallery: {},
      items: []
    }
  },
  components: {
    Carousel,
    Expander,
    Slide,
    'v-photoswipe': PhotoSwipe,
    'v-photoswipe-gallery': PhotoSwipeGallery
  },

  methods: {
	  isOpen () {
		  this.isOpen = !this.isOpen
		  this.remo
	  },
	  toggleMuted () {
		  this.muted = !this.muted
	  },
    getContent (uid) {
      this.$prismic.client.getByUID('page', uid)
        .then((document) => {
          if (document) {
            this.documentId = document.id
            this.fields.uid = document.uid
            this.fields.title = document.data.title
            this.fields.date = document.data.date
            this.fields.description = document.data.seo_description
            this.fields.template = document.data.template
						this.fields.featured_image = document.data.featured_image
						this.fields.featured_image_url = document.data.featured_image.url
						this.fields.featured_image_caption = document.data.featured_image_caption
						this.fields.desktop_featured_image_crop_point = document.data.desktop_featured_image_crop_point
	          this.slices = document.data.body
	          this.tickers = document.data.body1
	          
	          this.items.push({
		          src: document.data.featured_image.url,
		          w: document.data.featured_image.dimensions.width,
		          h: document.data.featured_image.dimensions.height,
		          title: prismicDOM.RichText.asHtml(document.data.featured_image_caption, innerSingleParagraph),
		          index: 0
		        })
            
            for (var [i, slice] of this.slices.entries()) {
	            
						  if (slice.slice_type == 'image') {
							  this.items.push({
				          src: slice.primary.section_image.url,
				          w: slice.primary.section_image.dimensions.width,
				          h: slice.primary.section_image.dimensions.height,
				          title: prismicDOM.RichText.asHtml(slice.primary.section_image_caption, innerSingleParagraph),
				          index: i
				        })
						  }
						  
						  else if (slice.slice_type == 'carousel') {
							  
							  for (var [x, item] of slice.items.entries()) {
									
									this.items.push({
					          src: item.slide_image.url,
					          w: item.slide_image.dimensions.width,
					          h: item.slide_image.dimensions.height,
					          title: prismicDOM.RichText.asHtml(item.slide_caption, innerSingleParagraph),
					          index: i.x
					        })
								}
						  }
						  
						  else if (slice.slice_type == 'image_grid') {
							  
							  for (var [x, item] of slice.items.entries()) {
									
									this.items.push({
					          src: item.grid_image.url,
					          w: item.grid_image.dimensions.width,
					          h: item.grid_image.dimensions.height,
					          title: prismicDOM.RichText.asHtml(item.grid_image_caption, innerSingleParagraph),
					          index: i.x
					        })
								}
						  }
						  
						}
						
            } else {
            this.$router.push({ name: 'not-found' })
          }
        })
	},
	
    showPhotoSwipe (index) {
      this.isOpen = true
      this.$set(this.options, 'index', index)
    },
    hidePhotoSwipe () {
      this.isOpen = false
    },
    expandIt() {
      toggleClass(this, 'addClass', 'loaded');
    },
    sanitizeTitle (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd');
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '');
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-');
      
      return slug;
    },
    humanizeSlug (slug) {
	    if (slug != null) {
	    var frags = slug.split('-');
	    var i;
	    for (i=0; i<frags.length; i++) {
		    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
		  }
		  return frags.join(' ');
		  } else { return "" };
    },
    scrollToSection (section) {
	    function goTo (refName) {
		    refName = "#" + refName;	
		    console.log(refName);	    
		    var el = document.querySelector(refName);
		    console.log(el);
		    var y = el.offsetTop + 160;
		    window.scrollTo(0,y);
	    };
	    if (section != null) {
		    goTo(section);
	    }
	    else { return false; console.log('no sub-section'); }
    }
  },
  created () {
    this.getContent(this.$route.params.uid)
  },

  mounted() {
	toggleClass(document.getElementById("app"), 'removeClass', 'sched-open')  
	
	console.log('featured ' + this.fields.featured_image)
	
	setTimeout(()=> {
      this.loading = false
      this.$nextTick(() =>
      console.log(this.$refs),
      this.scrollToSection (this.$props.active_section)
      )
    }, 1000);

	// Give Lively Widget

	// console.log(this.slices)
	
	

	const gl=document.createElement('script');
	
	gl.src = "https://secure.givelively.org/widgets/simple_donation/performa-inc/commission-support-2021.js?show_suggested_amount_buttons=true&show_in_honor_of=true&address_required=false&has_required_custom_question=false&suggested_donation_amounts[]=5000&suggested_donation_amounts[]=10000&suggested_donation_amounts[]=15000&suggested_donation_amounts[]=20000";document.getElementsByTagName('head')[0].appendChild(gl)

    // gl.src='https://secure.givelively.org/widgets/simple_donation/performa-inc.js?show_suggested_amount_buttons=true&show_in_honor_of=false&address_required=false&suggested_donation_amounts[]=50&suggested_donation_amounts[]=150&suggested_donation_amounts[]=250&suggested_donation_amounts[]=500&suggested_donation_amounts[]=1500&suggested_donation_amounts[]=2500&suggested_donation_amounts[]=10000&suggested_donation_amounts[]=20000';document.getElementsByTagName('head')[0].appendChild(gl);
  },
  metaInfo () {
	  
	  if (this.fields.description == null) {
		  var description = 'Founded by RoseLee Goldberg in 2004, Performa is the leading organization dedicated to exploring the critical role of live performance in the history of twentieth-century art and to encouraging new directions in performance for the twenty-first century.';
	  } else {
		  	  var description = this.fields.description;
	  }
	  	  
    return {
      title: this.fields.title,
      meta: [
		    {vmid: 'description', name: 'description', content: description},
		    
		    {vmid: 'og:title', property: 'og:title', content: this.fields.title},
		    {vmid: 'og:site_name', property: 'og:site_name', content: 'Performa'},
		    // The list of types is available here: http://ogp.me/#types
		    {vmid:'og:type', property: 'og:type', content: 'website'},
		    // Should be the the same as your canonical link, see below.
		    {vmid:'og:url', property: 'og:url', content: 'https://performa-arts.org/' + this.fields.uid},
		    // Often the same as your meta description, but not always.
		    {vmid:'og:description', property: 'og:description', content: description},
		    {vmid:'og:image', property: 'og:image', content: this.fields.featured_image_url},
		    
		
		    {vmid: 'twitter:card', name: 'twitter:card', content: 'summary'},
		    {vmid: 'twitter:site', name: 'twitter:site', content: 'https://performa-arts.org/' + this.fields.uid},
		    {vmid: 'twitter:title', name: 'twitter:title', content: this.fields.title + ' - Performa'},
		    {vmid: 'twitter:description', name: 'twitter:description', content: description},
		    {vmid: 'twitter:creator', name: 'twitter:creator', content: '@PerformaNYC'},
				{vmid: 'twitter:image', name: 'twitter:image', content: this.fields.featured_image_url},
		
		    {vmid: 'itemprop-name', itemprop: 'name', content: this.fields.title + ' - Performa'},
		    {vmid: 'itemprop-description', itemprop: 'description', content: description}
		  ]
    }
  },
  beforeRouteUpdate (to, from, next) {
	  this.items = []
    this.getContent(to.params.uid)
    next()
  }
}
</script>

<style>
	
.pswp__caption__center {
	color: $tru-white !important;
	line-height: 1 !important;
	max-width: 50% !important;
	font-size: 12px !important;
	pointer-events: none !important;
}

.pswp__top-bar {
	display: none;
}


.text .underlined, .expander .underlined {
  font-family: "Lars Sans Condensed", Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
  border-bottom: 1px #000000 solid;
  font-size: 0.85em;
}
video {
	max-width: 100%;
}
</style>